import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../utility';

const initialState = {
    errorFileUpload:'',
    licenseSupportedFiles:[],
    employementSupportedFiles:[]
}

const uploadFileReducer =(state = initialState,action)=>{
    switch(action.type.type){
            case actionTypes.UPLOAD_FILE_FAILED:
                return updateObject(state, {
                    errorFileUpload:action.type.error.msg
                })
            case actionTypes.UPDATE_LICENSE_FILES:
                return updateObject(state, {
                    licenseSupportedFiles: [...state.licenseSupportedFiles, action.type.response]
                })
            case actionTypes.UPLOAD_EMPLOYEMENT_FILES:
                return updateObject(state, {
                    employementSupportedFiles: [...state.employementSupportedFiles, action.type.response]
                })
            default:{
                return state;
            }
        }
}

export default uploadFileReducer;